import {
  CHANGE_VISIBLE_BALANCE,
  CHANGE_VISIBLE_NAV,
  CHANGE_POSITION_MENU,
  CHANGE_JACKPOTS_VISIBLE,
} from "../constants";

export function changeBalanceVisibility(isVisible) {
  return {
    type: CHANGE_VISIBLE_BALANCE,
    payload: isVisible,
  };
}

export function changeNavigationVisibility(isVisible) {
  return {
    type: CHANGE_VISIBLE_NAV,
    payload: isVisible,
  };
}

export function changeMenuPosition(position) {
  return {
    type: CHANGE_POSITION_MENU,
    payload: position,
  };
}

export function changeJackpotsVisible(isVisible) {
  return {
    type: CHANGE_JACKPOTS_VISIBLE,
    payload: isVisible,
  };
}
